import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { formatArrivalDate } from '../../../../../../utils/Functions';
import { ItineraryService } from '../../../../../../shared/itinerary.service';
import { RestService } from '../../../../../../shared/rest.service';
import { BsModalRef, BsModalService, ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import { MaterialModalConfirmComponent } from 'app/shared/material-modal-confirm/material-modal-confirm.component';
import { ModalLoadingComponent } from 'app/shared/modal-loading/modal-loading.component';
import { MaterialModalAlertComponent } from 'app/shared/material-modal-alert/material-modal-alert.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ResultsSearchService } from 'app/home/results-search.service';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-item-transport',
  templateUrl: './item-transport.component.html',
  styleUrls: ['./item-transport.component.scss'],
  providers: [CurrencyConverterPurePipe]
})
export class ItemTransportComponent implements OnInit {
  @Input() data: any;
  @Input() isCheckIn: boolean;
  @Input() partialReserve: boolean;
  @Input() permissions: any[] = [];
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Input() clientSetting: any;
  @Output() itemToPartial = new EventEmitter<number>();
  @Output() itemDelete = new EventEmitter<any>();
  @Output() editItem = new EventEmitter<any>();
  @Output() cancelOrDeleteEmitter = new EventEmitter<any>();
  @Output() delete = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<string>();
  fontSizeAdjustments = { 6: -1, 8: -2, 10: -5 };
styleSidebar: any;
  @ViewChild('modalRooms') modalRooms: ModalDirective;

  dato
  imgTransfer:string = '';
  currencyItinerary: string;
  bsModalRef?: BsModalRef;
  currentDate = new Date();
  public formatDate = formatArrivalDate;
  constructor(private itineraryService: ItineraryService,
              private restService :RestService,
              private ngxSpinner: NgxSpinnerService,
              public _restService: RestService,
              public userService : UserService,
              private modalService: BsModalService,
              private notificationService: NotificationService,
              private dialog: MatDialog,
              private resultsSearch: ResultsSearchService,
              private router: Router,
              private currencyPipe: CurrencyConverterPurePipe
            ) { }

  ngOnInit() {
    const payloadTransport = [];
    payloadTransport.push(this.data);
     this.styleSidebar = JSON.parse(this.clientSetting.clients_setting_app_booking?.bookingFlow_sidebar);
    this.imgTransfer = this.data.images ? this.data.images[0].thumbnail : 'assets/img/app/transport.png';
    this.currencyItinerary = this.data?.currency;
    //this.getProduct();
    console.log(this.data)
  }

  getProduct(){

    if (this.data.payloadUpdate) {

      this.restService.doPost('app', 'search/products', this.data.payloadUpdate).subscribe(
        (response:any) => {
          if (response && response.status && response.results) {
            if (response.results[0] !== undefined) {
              this.data.product = response.results[0];
            } else {
              this.data.product = response.results;
            }
          }
        }, error => {
          console.log(error.message);
        }
      );
    }
  }

  toPartialReserve(event, item: any){
    if ( event.target.checked ) {
      this.itineraryService.updateItineraryPartial(item);
      this.itemToPartial.emit(1);
    } else {
      this.itineraryService.updateItineraryPartial(item,true);
      this.itemToPartial.emit(-1);
    }
  }

  subtractDays(date){
    return moment(moment(date)).subtract(2, 'days').format('YYYY-MM-DD');
  }
  // Pasar primer letra de cada palabra a mayuscula en una cadena
  stingUpperCase(str){
    let e = str?.toLowerCase()
    return e?.replace(/\b\w/g, l => l.toUpperCase())
  }
  fontPrice(price:any){
    if((price?.length - 6) > 0){
      const fact = price.length - 6
      const size = 25 - (1.5 * fact)
      return size + 'px'
    }
  }

edit(item: any){

    // modo quoute
    if (item.status_id == 1) {
      const arrival = item.arrivalDate;
      const departure = item.departureDate;

      let message = '';

      if(arrival && departure && arrival === departure) {
        message = "¿Deseas eliminar este producto y buscar un nuevo traslado para fecha " +
          this.formatDateSlash(arrival) +
          ", para " +
          item.paxAdults +
          " adultos?";
      } else {
        message = "¿Deseas eliminar este producto y buscar un nuevo traslado del " +
        this.formatDateSlash(arrival) +
        " hasta " +
        this.formatDateSlash(departure) +
        " para " +
        item.paxAdults +
        " adultos?";
      }


      const initialState: ModalOptions = {
        initialState: {
          title: 'Eliminar',
          message: message.replace(/\?/g, '?<br />'),
          icon: 'assets/icons/itinerary-detail/04-01.svg'
        }
      };

      this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
      const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe(async (result: boolean) => {
        if(result) {
          await this.makePayload(item);
        } else {

        }
        confirmSubscription.unsubscribe();
      });
    }
  }

    makePayload(item: any) {
      const _payload = [];

      let payload: any;
      let form: any;
      switch (item.category_id) {
        case 1:
          payload = item.payloadUpdate.products[0];
          form = item.form;
          break;
        case 2:
          payload = item.payloadUpdate.products[0];
          form = item.form;
          break;
        case 6:
          payload = item.payload[0];
          form = item.form;
          break;
        case 8:
          payload = item.payload[0];
          form = item.formTransport;
          break;
        case 10:
          payload = item.payload;
          form = item.form;
          break;
        default:
          payload = item.payloadUpdate?.products?.[0] ?? item.payload?.[0];
          form = item.form ?? item.formTransport;
          break;
      }
      _payload[0] = payload;

      localStorage.setItem("form", JSON.stringify(form));
      localStorage.setItem("payload", JSON.stringify(_payload));
      this.openModalLoading(JSON.parse(localStorage.getItem("payload")));
      this.restService.doPost("app", "search", payload).subscribe(
              (response: any) => {
                if (response !== null && response.results !== null) {

                  const payloadArray = [payload];
                  this.resultsSearch._setPayload(payloadArray);
                  localStorage.setItem("form", JSON.stringify(form));
                  localStorage.setItem("payload", JSON.stringify(payloadArray));
                  this.resultsSearch._setOrigin(item.categoryName);

                  this._setSearchIdInResults(response);
                  if (response.results.length > 0) {
                    this._handleResponse(response, item.categoryName, item);
                    this.itineraryService.remove(item);
                    this.dialog.closeAll();
                    this.itineraryService.notifyModalClosed(true);
                    this.router.navigate(["/results"]);
                  } else {
                    var dialogRef = this.dialog.open(MaterialModalAlertComponent, {
                      height: "auto",
                      width: "350px",
                      data: "No se encontraron Resultados",
                      disableClose: true,
                    });
                  }
                }
              },
              (error) => {
                const message = "Ocurrió un error al intentar encontrar productos";
                this.dialog.closeAll();
                var dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
                  width: "450px",
                  data: {message: message},
                  disableClose: true,
                });
                dialogRef.afterClosed().subscribe((result) => {
                  if (result) {
                    this.makePayload(item);
                  } else {
                    this.dialog.closeAll();
                  }
                });
              }
            );
    }

      _handleResponse(response: any, categoryName: string, payload: any) {
    if (response && response.results != null) {
      try {
        let _resultsQuery: any;
        _resultsQuery = response.results;
        _resultsQuery.categoryName = categoryName;
        _resultsQuery.arrivalDate = payload.arrivalDate;
        _resultsQuery.destination = payload.destination.iata_code;
        if (!response.results.length) {
          _resultsQuery.noResultMessage = "No results found for the search";
        }
        const arrayResults = [_resultsQuery];

        this.resultsSearch._setResponse(arrayResults);
      } catch (e) {
        console.log("error", e);
      }
    }
  }

  formatDateSlash(date: any): string {
    if (!date || typeof date !== 'string' || !date.includes('-')) return '';
    const dateOnly = date.split(' ')[0];
    const parts = dateOnly.split('-');
    if (parts.length !== 3) return '';
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

        _setSearchIdInResults(response: any) {
    response.results.forEach((obj) => {
      obj.searchId = response.searchId;
    });
  }

          openModalLoading(data: any) {
            var dialogRef = this.dialog.open(ModalLoadingComponent, {
              width: "650px",
              id: "loadModal",
              data: data,
              disableClose: true,
            });

            /* dialogRef.afterClosed().subscribe(result => {
              });*/
          }

removeItem(item: any) {
    let message = "";

    if ((item.status_id == 1) ||  (item.status_id == 5)) {
      message = "Esta seguro de Eliminar el Producto?";
    }
    if (item.status_id == 2) {
      if(this.verifiedReservationId(item)) {
        message = "Hay más productos con el mismo localizador ¿Está seguro de cancelar los productos?";
      } else {
        message = "¿Esta seguro de cancelar el producto?";
      }
    }

    const initialState: ModalOptions = {
      initialState: {
        title: item.status_id === 2 ? 'Cancelar' : 'Eliminar',
        message: message.replace(/\?/g, '?<br />'),
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result) {
          const paxesQty = {
            destination: item.destination?.iata_code,
            adults: Number(item.paxAdults),
            children: Number(item.paxChildren)
          }
          this.userService.itineraryActive[0]['destination'].forEach((destination: any) => {
              if(destination.iata_code === paxesQty.destination) {
                destination.destination_info.adults -= paxesQty.adults;
                destination.destination_info.childs -= paxesQty.children;
              }
          });
        if((item.status_id == 1)  ||  (item.status_id == 5) ) {
          this.deleteItem(item);
        }
        if (item.status_id == 2) {
          this.cancelReservation(item);
        }
      } else {

      }
      confirmSubscription.unsubscribe();
    });
  }

    verifiedReservationId(item): boolean {
    let matchReservationId: any[] = [];
    switch(item?.category_id) {
  case 1:
          matchReservationId = this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId);
    break;
  case 2:
          matchReservationId = this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.additionalInfo?.idReservation);
    break;
  case 6:
          matchReservationId = this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.additionalInfo?.idReservation);
    break;
  case 8:
          matchReservationId = this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId);
    break;

}

    return matchReservationId && matchReservationId.length > 1;
  }



  deleteItem(item: any) {
    this.itineraryService.remove(item !== undefined ? item : item);
    setTimeout(() => {
      this.delete.emit(item.id);
     this.userService.updateProductsPrices(item.itinerary_id);
    }, 1000);
  }

  cancelReservation(item: any) {



this.ngxSpinner.show();
let cancelData: any = {};
switch(item?.category_id) {
  case 1:
    cancelData['providerId'] = item?.providerId
    cancelData['reservationLocator'] = item?.resultReserve?.providerReservationId;
    break;
  case 2:
    cancelData['providerId'] = item?.providerId;
    cancelData['reservationLocator'] = item?.resultReserve?.additionalInfo?.idReservation;
    break;
  case 6:
    cancelData['providerId'] = item?.providerId;
    cancelData['reservationLocator'] = item?.resultReserve?.additionalInfo?.idReservation;
    break;
  case 8:
    cancelData['providerId'] = item?.providerId
    cancelData['reservationLocator'] = item?.resultReserve?.providerReservationId;
    cancelData['productsId'] = [item.id];
    break;

}

const itemCancellation = this.userService.itineraryActive[0].items.find(c => c.id === item.id);

itemCancellation.amount_convert_cancellation= this.getCancellationPolicies(itemCancellation.category_id, item);
this.userService.itineraryActive[0].clientId = this.itineraryService.itinerary.client_id;

   this._restService.doPut("app", `products/cancelReservation/${item?.itinerary_id}`, cancelData).subscribe({
    next: (res: any) => {
      this.ngxSpinner.hide();
      this.notificationService.success('Su producto fue cancelado con éxito');
      this.cancel.emit(item.id);


      this.itineraryService.updateItinerary(this.userService.itineraryActive[0], false);
    },
    error: (error: HttpErrorResponse) => {
      this.ngxSpinner.hide();
      this.notificationService.error('Ocurrio un error');
      console.log(error);
    }
  });
  }

getCancellationPolicies(category, item) {
    const currentDate = new Date();
    const defaultPolicy = {
        currency: this.currencyAgency?.code,
        from: currentDate,
        amount: 0,
        apply: false
    };

    // Determinar el array de políticas según la categoría
    let policies = [];
    if (category === 1) {
        policies = item.room?.cancellationPolicy || [];
    } else if (category === 8) {
        policies = item.cancellationPolicies || [];
    }

    // Si no hay políticas, retornar el default
    if (policies.length === 0) {
        return [defaultPolicy];
    }

    // Ordenar políticas por fecha 'from'
    const sortedPolicies = [...policies].sort((a, b) =>
        new Date(a.from).getTime() - new Date(b.from).getTime()
    );

    // Encontrar la política aplicable
    let applicableIndex = -1;
    for (let i = 0; i < sortedPolicies.length; i++) {
        if (new Date(sortedPolicies[i].from) <= currentDate) {
            applicableIndex = i;
        } else {
            break;
        }
    }

    // Preparar el resultado con el campo apply
    const result = sortedPolicies.map((policy, index) => {
      const baseRate = this.currencies.find(c => c.code === policy.currency)?.rate || 1;
      const targetRate = this.currencyAgency?.rate || 1;

        const isApplicable = index === applicableIndex;
        const amount = (policy.amount / baseRate) * targetRate;

        return {
            ...policy,
            currency: this.currencyAgency?.code,
            amount: amount,
            apply: isApplicable
        };
    });

    // Si no hay ninguna aplicable y hay políticas, marcamos todas como no aplicables
    if (applicableIndex === -1 && result.length > 0) {
      const targetRate2 = this.currencyAgency?.rate || 1;
      return result.map(policy => ({
            ...policy,
            currency: this.currencyAgency?.code,
            amount: (policy.amount / this.currencies.find(c => c.code === policy.currency)?.rate) * targetRate2,
            apply: false
        }));
    }

    return result;
}

  extractNameTransport(form: any, type: string): string {

    switch(type) {
      case 'origin':
        switch(form.payload[0].transfers.pickupLocation.type) {
          case 'hotel':
            return `${form.formTransport?.firstOrigin?.name ||form.formTransport?.firstOrigin?.hotel_name}`;
          case 'airport':
            return `${form.formTransport?.firstOrigin?.name} (${form.formTransport?.firstOrigin?.iata})`;
          case 'destination':
            return `${form.formTransport?.firstOrigin?.city_name}`;
        }
      case 'destination':
        switch(form.payload[0].transfers.dropoffLocation.type) {
          case 'hotel':
            return `${form.formTransport?.firstDestination?.name || form.formTransport?.firstDestination?.hotel_name}`;
          case 'airport':
            return `${form.formTransport?.firstDestination?.name} (${form.formTransport?.firstDestination?.iata})`;
          case 'destination':
            return `${form.formTransport?.firstDestination?.city_name}`;
        }
    }
  }

    extractAddressType(form: any, type: string): string {
    switch(type) {
      case 'origin':
        switch(form.payload[0].transfers.pickupLocation.type) {
          case 'hotel':
            return `${form.payload[0].transfers.pickupLocation.address} (${form.payload[0].transfers.pickupLocation.origin})`;
          case 'airport':
            return `${form.formTransport?.firstOrigin?.name} (${form.formTransport?.firstOrigin?.iata})`;
          case 'destination':
            return `${form.formTransport?.firstOrigin?.city_name} (${form.formTransport?.firstOrigin?.country_code})`;
        }
      case 'destination':
        switch(form.payload[0].transfers.dropoffLocation.type) {
          case 'hotel':
            return `${form.payload[0].transfers.dropoffLocation.address} (${form.payload[0].transfers.dropoffLocation.destination})`;
          case 'airport':
            return `${form.formTransport?.firstDestination?.name} (${form.formTransport?.firstDestination?.iata})`;
          case 'destination':
            return `${form.formTransport?.firstDestination?.city_name} (${form.formTransport?.firstDestination?.country_code})`;
        }
    }
  }

    getTypeWay(typeWay: any): string {

    if(typeWay !== undefined) {
      return typeWay === 1 ? 'IDA' : 'VUELTA';
    } else {
      return '  ';
    }
  }

    getMessageFirstTime(pickupOrDropoff: any,input: string): string {

  let firstOrigin = {};
  let firstDestination = {};

  firstOrigin = input === 'origin' ? pickupOrDropoff : {};
  firstDestination = input === 'destination' ? pickupOrDropoff : {};

  let message: string = '';
  const messageFly = 'Hora arribo del vuelo';
  const messageDestination = 'Hora pickup del hotel';

  if(firstOrigin && firstOrigin['type']) {
    message = firstOrigin['type'] === 'airport' ? messageFly : messageDestination;
  }

  if(message === '') {
    message = firstDestination && firstDestination['type'] === 'airport' ? messageFly : messageDestination;
  }

  return message

  }

    getDateArrivalApprove(dateArrival: any): boolean {
    return new Date(dateArrival) >= this.currentDate;
  }

    getRateClass(item: any): string {
    return item?.pricing?.rateClass ? item?.pricing?.rateClass : '';
  }

    getPrice(item): number {

      if(item.status_id == 5) {
        return 0;
      }

      let price: number;
      if(!item.isPendigApprovePay && !item.isPaidAgency && !item.isPaidProvider) {
        price = item.netPriceAgent;

        price = this.currencyPipe.transform(
                                              price,
                                              item?.currency,
                                              this.currencyAgency?.code,
                                              this.currencies
                                            );
      }

      if(item.isPendigApprovePay || item.isPaidAgency || item.isPaidProvider) {
        if(item.converted_amounts) {
          price = item.converted_amounts.netPriceAgent;
        } else {
          price = item.netPriceAgent;
        }


      }

      return price

    }

  /**
   * Determina si es Transfer-out.
   * `firstWay === 2` representa el traslado de vuelta según el modelo.
   */
  get isTransferOut(): boolean {
    return this.data?.firstWay === 2;
  }

  /**
   * Calcula la hora estimada de llegada sumando `entryTravelTime` (minutos) a `firstTime`.
   * Devuelve `null` si falta algún input o si el formato de `firstTime` no es HH:MM.
   * Si la suma cruza medianoche, devuelve el resultado módulo 24.
   * @returns Hora estimada en formato HH:MM, o null si no se puede calcular.
   */
  getEstimatedArrival(): string | null {
    const firstTime: string | undefined = this.isTransferOut ? this.data?.formData?.firstTime : this.getHour(this.data?.timing.return.returnDepartureDatetime);
    const travelMinutes: number | string | undefined = this.isTransferOut ? this.data?.timing?.entry?.entryTravelTime : this.data?.timing?.return.returnTravelTime;
    if (!firstTime || travelMinutes === undefined || travelMinutes === null) {
      return null;
    }
    const match = /^(\d{1,2}):(\d{2})$/.exec(firstTime);
    if (!match) return null;
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (isNaN(hours) || isNaN(minutes)) return null;
    const totalMinutes = hours * 60 + minutes + Number(travelMinutes);
    const arrivalHours = Math.floor((totalMinutes / 60) % 24);
    const arrivalMinutes = totalMinutes % 60;
    return `${String(arrivalHours).padStart(2, '0')}:${String(arrivalMinutes).padStart(2, '0')}`;
  }


  getHour(dateTime: string): string {
  if (!dateTime) return '';

  const parts = dateTime.split(' ');
  if (parts.length > 1) {
    const timeParts = parts[1].split(':');
    // Solo devuelve horas y minutos (ignora segundos si existen)
    return `${timeParts[0]}:${timeParts[1]}`;
  }
  return '';
}

}
